import React from 'react'

// Page components
import TopNavbar from "../../components/pagecomponents/ts/topNavbar";
import Footer from "../../components/pagecomponents/ts/Footer";
import PageBanner from '../../components/pagecomponents/ts/pageBanner';

// Bootstrap Components
import Container from 'react-bootstrap/Container';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

export const WeatherPanel = () => {
  console.log("Hello");
  return (
    <div>
      <div>
        <TopNavbar />
      </div>

      <div>
        <PageBanner 
          title={"氣象儀表板"} 
          description={"為你帶來最優質的海洋氣象資料"} 
          icon={"faSolarPanel"} 
          id={"mainPageBanner"}
        />
      </div>
      
      <div>
        
      </div>

      <div>
        <Footer />
      </div>
    </div>

    
  )
}
